"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.info = void 0;
var info = {
  50: '#EDF0FF',
  100: '#DFD6FF',
  200: '#A086FF',
  300: '#815EFF',
  400: '#714AFF',
  500: '#6136FF',
  600: '#5731E6',
  700: '#4E2BCC',
  800: '#14003b',
  900: '#120036',
  black_rgba: '18, 0, 54'
};
exports.info = info;
//# sourceMappingURL=info.js.map